"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseToJSON = exports.PurchaseFromJSONTyped = exports.PurchaseFromJSON = exports.instanceOfPurchase = void 0;
var runtime_1 = require("../runtime");
var PurchasePurchaseItemsSummaryInner_1 = require("./PurchasePurchaseItemsSummaryInner");
var PurchaseShippingTo_1 = require("./PurchaseShippingTo");
/**
 * Check if a given object implements the Purchase interface.
 */
function instanceOfPurchase(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPurchase = instanceOfPurchase;
function PurchaseFromJSON(json) {
    return PurchaseFromJSONTyped(json, false);
}
exports.PurchaseFromJSON = PurchaseFromJSON;
function PurchaseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': !(0, runtime_1.exists)(json, 'email') ? undefined : json['email'],
        'referenceId': !(0, runtime_1.exists)(json, 'reference_id') ? undefined : json['reference_id'],
        'firstName': !(0, runtime_1.exists)(json, 'first_name') ? undefined : json['first_name'],
        'lastName': !(0, runtime_1.exists)(json, 'last_name') ? undefined : json['last_name'],
        'items': !(0, runtime_1.exists)(json, 'items') ? undefined : json['items'],
        'totalActiveQuantity': !(0, runtime_1.exists)(json, 'total_active_quantity') ? undefined : json['total_active_quantity'],
        'purchaseItemsSummary': !(0, runtime_1.exists)(json, 'purchase_items_summary') ? undefined : (json['purchase_items_summary'].map(PurchasePurchaseItemsSummaryInner_1.PurchasePurchaseItemsSummaryInnerFromJSON)),
        'shippingTo': !(0, runtime_1.exists)(json, 'shipping_to') ? undefined : (0, PurchaseShippingTo_1.PurchaseShippingToFromJSON)(json['shipping_to']),
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
        'userCancelable': !(0, runtime_1.exists)(json, 'user_cancelable') ? undefined : json['user_cancelable'],
        'subtotal': !(0, runtime_1.exists)(json, 'subtotal') ? undefined : json['subtotal'],
        'shippingCost': !(0, runtime_1.exists)(json, 'shipping_cost') ? undefined : json['shipping_cost'],
        'tax': !(0, runtime_1.exists)(json, 'tax') ? undefined : json['tax'],
        'currentTotal': !(0, runtime_1.exists)(json, 'current_total') ? undefined : json['current_total'],
        'voucherCode': !(0, runtime_1.exists)(json, 'voucher_code') ? undefined : json['voucher_code'],
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : json['created_at'],
    };
}
exports.PurchaseFromJSONTyped = PurchaseFromJSONTyped;
function PurchaseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'reference_id': value.referenceId,
        'first_name': value.firstName,
        'last_name': value.lastName,
        'items': value.items,
        'total_active_quantity': value.totalActiveQuantity,
        'purchase_items_summary': value.purchaseItemsSummary === undefined ? undefined : (value.purchaseItemsSummary.map(PurchasePurchaseItemsSummaryInner_1.PurchasePurchaseItemsSummaryInnerToJSON)),
        'shipping_to': (0, PurchaseShippingTo_1.PurchaseShippingToToJSON)(value.shippingTo),
        'status': value.status,
        'user_cancelable': value.userCancelable,
        'subtotal': value.subtotal,
        'shipping_cost': value.shippingCost,
        'tax': value.tax,
        'current_total': value.currentTotal,
        'voucher_code': value.voucherCode,
        'created_at': value.createdAt,
    };
}
exports.PurchaseToJSON = PurchaseToJSON;
